import React, { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const MarketsDefault = Loadable(lazy(() => import('views/dashboard/Markets')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/Typography')));
const UtilsStrategies = Loadable(lazy(() => import('views/Strategies')));
const UtilsStrategiesPage = Loadable(lazy(() => import('views/StrategiesPage')));
const UtilsAccountsPage = Loadable(lazy(() => import('views/AccountPage')));
const UtilsAPIPage = Loadable(lazy(() => import('views/APIPage')));
const UtilsStockPage = Loadable(lazy(() => import('views/StockPage')));

const UtilsCode = Loadable(lazy(() => import('views/Code2')));
const UtilsPrediction = Loadable(lazy(() => import('views/Prediction')));
const UtilsNews = Loadable(lazy(() => import('views/News')));
const UtilsSquare = Loadable(lazy(() => import('views/Square')));
const UtilsCodeOld = Loadable(lazy(() => import('views/Code')));
const UtilsChat = Loadable(lazy(() => import('views/Chat')));
const UtilsStockSearch = Loadable(lazy(() => import('views/StockSearch')));
const UtilsComingSoon = Loadable(lazy(() => import('views/ComingSoon')));
const UtilsCashFlowManagement = Loadable(lazy(() => import('views/CashFlowManagement')));
const UtilsTradeOrderDevelopment = Loadable(lazy(() => import('views/TradeOrderDevelopment')));
const UtilsCashReconciliation = Loadable(lazy(() => import('views/UtilsCashReconciliation')));
const UtilsTradeOrder = Loadable(lazy(() => import('views/UtilsTradeOrder')));
const UtilsAddTradeOrder = Loadable(lazy(() => import('views/UtilsAddTradeOrder')));
const UtilsVerifyTradeOrder = Loadable(lazy(() => import('views/UtilsVerifyTradeOrder')));
const UtilsTradeOrderPositions = Loadable(lazy(() => import('views/UtilsTradeOrderPositions')));
const Securities = Loadable(lazy(() => import('views/securities/Securities')));
const Users = Loadable(lazy(() => import('views/users/Users')));
const AddUser = Loadable(lazy(() => import('views/users/AddUser')));
const EditUser = Loadable(lazy(() => import('views/users/EditUser')));
const CorporateAction = Loadable(lazy(() => import('views/CorporateAction')));
const AddCorporateAction = Loadable(lazy(() => import('views/AddCorporateAction')));
//-----------------------|| MAIN ROUTING ||-----------------------//

const MainRoutes = () => {
    const location = useLocation();

    return (
        <Route
            path={[
                '/dashboard',
                '/markets',
                '/utils/accounts/:id',
                '/utils/apis',
                '/utils/strategies',
                '/utils/strategies/:id',
                '/utils/stocks/:ticker',
                '/utils/apis/:id',
                '/utils/code',
                '/utils/code_old',
                '/utils/prediction',
                '/utils/news',
                '/utils/square',
                '/utils/chat',
                '/utils/stock-search',
                '/utils/coming-soon',
                '/utils/cash-flow-management',
                '/utils/trade-order-development',
                '/utils/cash-reconciliation',
                '/utils/trade-order',
                '/utils/trade-order/add-order',
                '/utils/trade-order/verify-order/:id',
                '/utils/trade-order-position',
                '/securities',
                '/users',
                '/users/add',
                '/users/edit/:id',
                '/corporate-action',
                '/corporate-action/add',
            ]}
        >
            <MainLayout>
                <Switch location={location} key={location.pathname}>
                    <AuthGuard>
                        <Route exact path="/dashboard" component={DashboardDefault} />
                        <Route exact path="/markets" component={MarketsDefault} />
                        <Route exact path="/utils/accounts/:id" component={UtilsAccountsPage} />
                        <Route exact path="/utils/apis" component={UtilsTypography} />
                        <Route exact path="/utils/strategies" component={UtilsStrategies} />
                        <Route exact path="/utils/strategies/:id" component={UtilsStrategiesPage} />
                        <Route exact path="/utils/apis/:id" component={UtilsAPIPage} />
                        <Route exact path="/utils/stocks/:ticker" component={UtilsStockPage} />
                        <Route exact path="/utils/code" component={UtilsCode} />
                        <Route exact path="/utils/prediction" component={UtilsPrediction} />
                        <Route exact path="/utils/news" component={UtilsNews} />
                        <Route exact path="/utils/square" component={UtilsSquare} />
                        <Route exact path="/utils/code_old" component={UtilsCodeOld} />
                        <Route exact path="/utils/chat" component={UtilsChat} />
                        <Route exact path="/utils/stock-search" component={UtilsStockSearch} />
                        <Route exact path="/utils/coming-soon" component={UtilsComingSoon} />
                        <Route exact path="/utils/cash-flow-management" component={UtilsCashFlowManagement} />
                        <Route exact path="/utils/trade-order-development" component={UtilsTradeOrderDevelopment} />
                        <Route exact path="/utils/cash-reconciliation" component={UtilsCashReconciliation} />
                        <Route exact path="/utils/trade-order" component={UtilsTradeOrder} />
                        <Route exact path="/utils/trade-order/add-order" component={UtilsAddTradeOrder} />
                        <Route exact path="/utils/trade-order/verify-order/:id" component={UtilsVerifyTradeOrder} />
                        <Route exact path="/utils/trade-order-position" component={UtilsTradeOrderPositions} />
                        <Route exact path="/securities" component={Securities} />
                        <Route exact path="/users" component={Users} />
                        <Route exact path="/users/add" component={AddUser} />
                        <Route exact path="/users/edit/:id" component={EditUser} />
                        <Route exact path="/corporate-action" component={CorporateAction} />
                        <Route exact path="/corporate-action/add" component={AddCorporateAction} />
                    </AuthGuard>
                </Switch>
            </MainLayout>
        </Route>
    );
};

export default MainRoutes;
